// ==============================================
// ============= SETUP APPLICATION ==============
// ==============================================

import "./styles/app.scss";

import bsn from "bootstrap.native";
import "./js/skip-link-focus-fix";
import VideoSlider from "./js/video-slider";
import VideoHero from "./js/video-hero";

import StackNavHandler from "./js/stack-nav";
import ContactUsModalForm from "./js/contact-us-modal-form";
import LeadModalForm from "./js/lead-modal-form";

import ContentVideoPlayer from "./js/content-video-player";
import ToggleCardTagsVisibility from "./js/toggle-card-tags-visibility";
import geoLocator from "./js/geo-locator";
import analyticsTracking from "./js/analytics-tracking";

window.geoLocatorRepository = {};
window.$ = window.jQuery = require("jquery");

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.expand = 1000;
window.lazySizesConfig.preloadAfterLoad = true;

// //import objectFitImages from 'object-fit-images';
require("./js/custom-wp-smartcrop.js");

require("lazysizes/plugins/object-fit/ls.object-fit.js");
require("lazysizes/plugins/parent-fit/ls.parent-fit");
require("lazysizes/plugins/respimg/ls.respimg");
require("lazysizes");

const wpDeployEnvMeta = document.querySelector('meta[name="wp-deploy-env"]');
const wpDeployEnv = wpDeployEnvMeta
  ? wpDeployEnvMeta.getAttribute("content")
  : "production";

require("../../../plugins/wp-libre-form/assets/scripts/wplf-form");
window.ajax_object = {
  ajax_url: "/wp-admin/admin-ajax.php",
  ajax_credentials: "same-origin",
  wplf_assets_dir: "/wp-content/plugins/wp-libre-form/assets"
};
require("mediaelement/full");

geoLocator.load(wpDeployEnv).then((response) => {
  analyticsTracking.addToDataLayer({
    user_country: response.countryISO2,
    user_currency: response.currency,
    user_geo_adwords: response.AAMarket
  });
  analyticsTracking.dispatchTrackingEvent("page-view-tracking-data-available");
  $(".site-country-input").val(response.countryISO3);
});

function init() {
  //objectFitImages('img');

  analyticsTracking.registerDomEvents();

  new StackNavHandler();
  new LeadModalForm(
    document.getElementById("newsletter-modal"),
    analyticsTracking,
    wpDeployEnv
  );
  new ContactUsModalForm(
    document.getElementById("contact-us-modal"),
    analyticsTracking
  );
  new VideoSlider(document.querySelector("#home-video-gallery .video-gallery"));
  new VideoHero(document.querySelector(".hero-video"));
  new ToggleCardTagsVisibility(
    document.querySelectorAll(".post-card, post-card-2")
  );

  let videos = document.querySelectorAll(".post-content video");
  new ContentVideoPlayer(videos);

  checkAndOpenModal();
}

if (document.readyState !== "loading") {
  init();
} else {
  document.addEventListener("DOMContentLoaded", init);
}

function checkAndOpenModal() {
  if (window.location.hash) {
    var element = $(window.location.hash);
    if (element.length && element.hasClass("modal")) {
      new bsn.Modal(element[0]).show();
    }
  }
}
